module.exports = __webpack_public_path__ + "img/tongji.0dee7807.png";